import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { AuthInvitationCompanySignUp } from "@/components/features/auth/invitation/one-time-password";

import { useConfirmInvitationCompanyOneTimePassword } from "./_hooks/use-confirm-invitation-company-one-time-password";
import { useGetInvitationCompanyOneTimeParams } from "./_hooks/use-get-invitation-company-one-time-params";

export const AuthInvitationOneTimePassPage = () => {
	const { companyID, oneTimePassword } = useGetInvitationCompanyOneTimeParams();
	const { canRender } = useConfirmInvitationCompanyOneTimePassword(oneTimePassword);

	/**
	 * @memo Fragment or Loading
	 */
	if (!canRender) return <></>;

	return (
		<PageMeta
			title="アカウント作成"
			url={generatePath(PATHS.AUTH.INVITATION.ONE_TIME_PASS, { companyID, oneTimePass: oneTimePassword })}
		>
			<AuthInvitationCompanySignUp companyID={companyID} oneTimePassword={oneTimePassword} />
		</PageMeta>
	);
};
